import React from "react"
import Image from "next/image"
import { isStorybook } from "utils/storybookUtils"

import { container, imageContainer } from "./AuthorHero.css"
import type { ReducedImage } from "types/cms"

type Props = {
  image: ReducedImage
}

export const AuthorHero: React.FC<Props> = ({ image }) => {
  const { filename, description, src } = image
  return (
    <div className={container}>
      <div className={imageContainer}>
        <Image
          src={src ?? ""}
          title={filename}
          alt={description ?? ""}
          unoptimized={isStorybook}
          width={1440}
          height={100}
          sizes="100vw"
          quality={50}
        />
      </div>
    </div>
  )
}
